import { baseServiceRequest } from "../baseServiceRequest"
import type { TTerms, ITermsError } from "./types"

export const getTerms = async (
  archiveLoc: string,
): Promise<TTerms | ITermsError> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/private_terms/archive`,
    params: { terms_archive_loc: archiveLoc },
  })
  const data = response.data

  return data as string
}
